<template>
	<li class="rsv_user_info_edit" v-show="isShow">
		<div v-if="isLoading" class="loading_bg" style="z-index: 999;">
			<div class="loading_wrap">
				<div class="loading_obj">
					<svg class="spinner" width="60px" height="60px" viewBox="0 0 66 66"
						xmlns="http://www.w3.org/2000/svg">
						<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30">
						</circle>
					</svg>
				</div>
			</div>
		</div>
		<div class="rsv_user_info_form">
			<!-- 이름 -->
			<div class="item">
				<div class="title_s">{{ $t('popup_user_reservation.label_name') }}</div>
				<div class="form_s">
					<span class="text_xs">{{ name }}</span>
				</div>
			</div>
			<!-- 전화번호 -->
			<div class="item">
				<div class="title_s">{{ $t('popup_user_reservation.label_phone') }}</div>
				<div class="form_s">
					<span class="text_xs">{{ phoneDisplay }}</span>
				</div>
			</div>
			<!-- 구분선 -->
			<div class="form_divider"></div>
			<!-- 차트번호 -->
			<div class="item" v-if="isUsingChatNumber">
				<div class="title_s">{{ $t('popup_user_reservation.label_chart_number') }}</div>
				<div class="form_s">
					<input type="text" class="input_xs" placeholder="000000" v-model="chartNumber">
				</div>
			</div>
			<!-- 생년월일 -->
			<div class="item">
				<div class="title_s">{{ $t('popup_user_reservation.label_birth') }}</div>
				<div class="form_s">
					<span class="input_date">
						<span class="sheet_weeks_picker_wrap">
							<v-icon class="ico_date" @click.stop="showCalendar()">mdi-calendar-blank</v-icon>
							<input readonly type="text" class="input_xs" :placeholder="$t('common.select')"
								v-model="birthString" @click.stop="showCalendar()">
						</span>
						<v-date-picker v-if="isShowCalendar" :locale="hospitalLocale" class="sheet_weeks_picker"
							color="#1F8FE5" v-model="calendarString" v-clickoutside:hideCalendar="undefined"
							width="265px" :max="today" :day-format="(date) => new Date(date).getDate()"
							@input="action_SelectBirthDate">
						</v-date-picker>
					</span>
				</div>
			</div>
			<!-- 성별 -->
			<div class="item">
				<div class="title_s">{{ $t('popup_user_reservation.label_gender') }}</div>
				<div class="form_s">
					<label class="radio_wrap">
						<input type="radio" name="gender" value="M" v-model="gender">
						<span class="checkmark"></span>
						{{ $t('common.male') }}
					</label>
					<label class="radio_wrap">
						<input type="radio" name="gender" value="F" v-model="gender">
						<span class="checkmark"></span>
						{{ $t('common.female') }}
					</label>
				</div>
			</div>
			<!-- 초/재진 -->
			<div class="item" v-if="isUsingFirstVisitStartDate">
				<div class="title_s">{{ $t('popup_user_reservation.label_visit_status') }}</div>
				<div class="form_s">
					<label class="radio_wrap">
						<input type="radio" name="isFirstVisit" :value="true" v-model="isFirstVisit">
						<span class="checkmark"></span>
						{{ $t('common.initial') }}
					</label>
					<label class="radio_wrap">
						<input type="radio" name="isFirstVisit" :value="false" v-model="isFirstVisit">
						<span class="checkmark"></span>
						{{ $t('common.return') }}
					</label>
				</div>
			</div>
		</div>
		<div class="btn_wrap_s">
			<button class="btn btn_dgray btn_s" @click="action_CancelEditBasicInfo">{{
				$t('popup_user_reservation.button_cancel_edit_basic_info') }}</button>
			<button class="btn btn_blue btn_s" @click="action_Update">{{
				$t('popup_user_reservation.button_save_edit_basic_info') }}</button>
		</div>
	</li>
</template>


<script>
import { deepCopy } from '@/util/deep-copy'
import { formatPhone } from '@/util/format-phone'

const moment = require("@/util/MPMoment");
import { mapActions, mapState } from "vuex";

import { closeAlertPopup, showAlertPopup } from '../../../../../sheet-alert'
import { closePopup } from '../../../../../sheet-overlays'
import { reservationSelection } from '../../../../../reservation-selection'
import { handleRefresh } from "../../../../../sheet-refresh";
import { editGuardState, registerGuard, unregisterGuard } from "../../popup-edit-guard";
import { useV2ReservationUserNoteUpdateMutation } from "@/composables/queries/v2reservationusernote/use-v2-reservationusernote-update-mutation";
import { useHServiceUpdateMutation } from "@/composables/queries/hservice/use-hservice-update-mutation";
import { isApiErrorWithCode } from "@/apis/instances/check-api-response";

export default {
	setup() {
		const { mutateAsync: updateUserNoteRequest } = useV2ReservationUserNoteUpdateMutation();
		const { mutateAsync: mutateHService } = useHServiceUpdateMutation();
		return { updateUserNoteRequest, mutateHService };
	},
	props: {
		isShow: Boolean,
		hservice: Object,
		noteContent: String,
	},
	data() {
		return {
			isLoading: false,

			name: "",
			chartNumber: "",
			birth: "",
			gender: "",
			phoneNumber: "",
			isFirstVisit: false,

			isShowCalendar: false,
			calendarString: moment().format("YYYY-MM-DD"),
			today: moment().format("YYYY-MM-DD"),
		};
	},
	watch: {
		isShow: function (newValue) {
			if (newValue == true) {
				this.setHServiceData(this.hservice);
				this.registerFunction();
			} else {
				this.unregisterFunction();
			}
		},
		hservice: {
			immediate: true,
			deep: true,
			handler: function (newValue) {
				this.setHServiceData(newValue);
			},
		},
		birth: {
			immediate: true,
			handler: function (newValue) {
				if (!newValue) {
					this.calendarString = moment().format("YYYY-MM-DD");
				} else {
					this.calendarString = moment(newValue).format("YYYY-MM-DD");
				}
			},
		},
		calendarString: {
			handler: function (newValue) {
				if (!newValue) {
					return;
				}
				this.birth = newValue;
			},
		},
	},
	computed: {
		...mapState(["SaaS"]),

		isWindow: function () {
			return this.SaaS?.isWindow ?? false;
		},
		countries() {
			const list = this.$store.state.servicesetting.countries;
			return Array.isArray(list) ? list : [];
		},
		// KR fallback 을 두지 않는다 — 국가코드가 없으면 접두 없이 국내 포맷으로 표시 (기존 동작)
		countryCodeId: function () {
			return this.hservice?.countryCode?._id ?? "";
		},
		countryDialingCode: function () {
			const code = this.hservice?.countryCode?.internationalDialingCodes;
			if (code) {
				return `(+${code})`;
			}
			// 국가 목록 API 는 _id 를 countryId 로 리네임해 내려준다
			const country = this.countries.find((c) => c.countryId == this.countryCodeId);
			if (country) {
				return `(+${country.internationalDialingCodes})`;
			}
			return "";
		},
		phoneDisplay: function () {
			if (this.phoneNumber == undefined || this.phoneNumber == "" || this.phoneNumber == "-") {
				return "-";
			}
			if (this.countryDialingCode) {
				return `${this.countryDialingCode} ${this.phoneNumber}`;
			}
			return this.phoneNumber;
		},
		birthString: function () {
			if (this.birth == undefined || this.birth == "") {
				return "-";
			}
			let birth = moment(this.birth);
			return birth.format("YYYY-MM-DD");
		},
		isUsingChatNumber: function () {
			return this.servicesetting?.setting?.usingChartNumber ?? false;
		},
		isUsingFirstVisitStartDate: function () {
			return this.servicesetting?.setting?.usingFirstVisitStartDate ?? false;
		},
	},
	mounted() { },
	destroyed() { },
	methods: {
		...mapActions(["AC_UpdatePushNotificationValue", "setToast"]),
		registerFunction() {
			registerGuard(
				"AlertEditUserBasicInfo",
				(resolve) => {
					this.showAlertEditInfoPopup(resolve);
				},
			);
		},
		unregisterFunction() {
			unregisterGuard("AlertEditUserBasicInfo");
		},
		// MARK: - Actions
		action_SelectBirthDate() {
			this.isShowCalendar = false;
		},
		action_CancelEditBasicInfo() {
			this.$emit("closeEditBasicInfo");
		},
		async action_Update() {
			if (await this.updateHService()) {
				this.action_CancelEditBasicInfo();
			}
		},
		// MARK: - Network
		async updateHService() {
			const model = {
				hserviceID: this.hservice._id,
				chartNumber: this.chartNumber,
				birth: this.birth.replaceAll("-", ""),
				gender: this.gender,
				isFirstVisit: this.isFirstVisit,
			};

			this.isLoading = true;
			let updatedHService;
			try {
				updatedHService = await this.mutateHService(model);
			} catch (err) {
				// 저장 실패 시 토스트를 띄우고 편집 상태를 유지한다
				// (레거시는 실패해도 selectedHService 를 undefined 로 덮어써 고객정보가 사라지는 문제가 있었음)
				this.isLoading = false;
				if (!isApiErrorWithCode(err)) {
					throw err;
				}
				console.log(err);
				this.setToast({
					isShow: true,
					text: "고객 정보 저장에 실패했습니다.",
				});
				return false;
			}
			this.isLoading = false;

			reservationSelection.selectedHService = updatedHService;
			handleRefresh();

			// update notification
			this.AC_UpdatePushNotificationValue({
				key: "d_HServiceUpdate_el",
				value: { createdAt: moment() },
			});

			return true;
		},
		async updateReservationUserNote() {
			let hospitalID = this.hospital.selectedHospital._id;
			let hserviceID = this.hservice._id;
			let userID = this.hservice.userID._id;
			let model = {
				hospitalID: hospitalID,
				hserviceID: hserviceID,
				userID: userID,
				content: this.noteContent,
			};
			this.isLoading = true;
			// 기존 동작 미러링: 봉투 에러를 확인하지 않던 호출 — 실패해도 진행 (로그만)
			await this.updateUserNoteRequest(model).catch((err) => console.log(err));
			this.isLoading = false;
		},

		// MARK: - Private
		clearHServiceData() {
			this.name = "";
			this.chartNumber = "";
			this.birth = "";
			this.gender = "";
			this.phoneNumber = "";
			this.isFirstVisit = false;
		},
		setHServiceData() {
			if (this.hservice == undefined) {
				this.clearHServiceData();
				return;
			}
			let hservice = deepCopy(this.hservice);
			this.name = hservice?.name ?? "";
			this.chartNumber = hservice?.chartNumber ?? "";
			this.birth = hservice?.birth ?? "";
			this.gender = hservice?.gender ?? undefined;
			this.isFirstVisit = hservice?.isFirstVisit;
			if (this.isWindow) {
				this.phoneNumber = hservice?.phone ?? "-";
			} else {
				this.phoneNumber = formatPhone(hservice?.phone) ?? "-";
			}
		},
		showAlertEditInfoPopup(resolve) {
			showAlertPopup(
				"AlertEditUserInfo",
				this.handleAlertEditPopupLeft,
				this.handleAlertEditPopupRight,
				undefined,
				resolve,
				resolve,
			);
		},
		showCalendar() {
			this.isShowCalendar = true;
		},
		hideCalendar() {
			this.isShowCalendar = false;
		},
		handleAlertEditPopupLeft(resolve) {
			// cancel
			this.action_CancelEditBasicInfo();
			if (resolve == undefined) {
				closeAlertPopup();
			} else {
				resolve();
			}
		},
		async handleAlertEditPopupRight(resolve) {
			// ok
			if (editGuardState.isUserNoteChanged) {
				await this.updateReservationUserNote();
			}
			if (await this.updateHService()) {
				if (resolve == undefined) {
					closePopup();
				} else {
					resolve(true);
				}
			}
		},
	},
};
</script>